import { i18n, i18nPlurals } from "../../domain/i18n.js";

export default {
  [i18nPlurals.brands["0"]]: 'Marken',
  [i18nPlurals.brands["1"]]: 'Marke',
  [i18nPlurals.brands["2"]]: 'Marken',

  [i18n.generic.authorizedBy]: 'authorized.by',
  [i18n.generic.brands]: '{count} [brands]',

  [i18n.alt.authorizedBySeal]: '(authorized.by)',
  [i18n.alt.tuvSeal]: '(TÜV Saarland ShopIdent)',

  [i18n.menu.checkAuthorizations.caption]: 'Autorisierung prüfen',
  [i18n.menu.imprint.caption]: 'Impressum',
  [i18n.menu.imprint.link]: 'https://www.authorized.by/impressum/',
  [i18n.menu.privacyPolicy.caption]: 'Datenschutz',
  [i18n.menu.privacyPolicy.link]: 'https://www.authorized.by/datenschutz/',

  [i18n.header.texts.full.isAuthorized1]: '{url}',
  [i18n.header.texts.full.isAuthorized2]: 'ist autorisierter Online-Partner',
  [i18n.header.texts.full.isAuthorized2_t0NotApproved]: 'Diese Website ist neu bei <a href="https://www.authorized.by/" target="_blank">authorized.by</a> und wartet auf die Genehmigung durch Brands',
  [i18n.header.texts.full.isAuthorized2_t0NoBrands]: 'Diese Website ist neu bei <a href="https://www.authorized.by/" target="_blank">authorized.by</a> und wartet auf Genehmigungen von Brands',
  [i18n.header.texts.full.isAuthorized3]: 'dieser {brands}',
  [i18n.header.texts.full.brands]: '{count} [brands]:',
  [i18n.header.texts.brandLink.multiple]: '{brandName} + {count} weiteren Marken',
  [i18n.header.texts.brandLink.two]: '{brandName} + 1 weitere Marke',
  [i18n.header.texts.brandLink.one]: '{brandName}',

  [i18n.contents.texts.lastVerified]: 'Zuletzt autorisiert',
  [i18n.contents.texts.lastVerified_t0NotApproved]: '<a href="https://app.authorized.by/" target="_blank">Warten auf Genehmigung</a>',
  [i18n.contents.texts.lastVerified_t0NoBrands]: '<a href="https://app.authorized.by/" target="_blank">Warten auf Autorisierung</a>',
  [i18n.contents.texts.tuvMember]: 'authorized.by | TÜV Saarland Group',
  [i18n.contents.texts.t0Message]: "Schauen Sie bald wieder vorbei, um mehr über autorisierte Marken zu erfahren!",

  [i18n.contents.texts.originalityConfirmedTitle]: "Originalität bestätigt",
  [i18n.contents.texts.originalityConfirmedText]: "{url} garantiert ausdrücklich die Originalität dieses Produktes.",
  [i18n.contents.texts.authRetailerTitle]: "Autorisierter Händler",
  [i18n.contents.texts.authRetailerText]: "{url} ist durch die Marke {brand} speziell für den Onlinevertrieb dieses Produktes autorisiert und ist vertrauenswürdiger Partner der Marke.",
  [i18n.contents.texts.shopCheckTitle]: 'Shop-Identität überprüft',
  [i18n.contents.texts.shopCheckText]: 'Die Unternehmensangaben zur Identität des Shopanbieters {url} wurden im Rahmen des TÜV Saarland ShopIdent Verfahrens zuletzt im {date} überprüft.',

  [i18n.contents.texts.shopCheckTitle_brandSponsored]: 'Sicher einkaufen',
  [i18n.contents.texts.shopCheckText_brandSponsored]: '{url} erfüllt die spezifischen Anforderungen von {brand} und ist vertrauenswürdiger Partner der Marke.',

  [i18n.contents.texts.originalityConfirmedTitle_d2c]: "Offizieller Markenshop",
  [i18n.contents.texts.originalityConfirmedText_d2c]: "{url} ist offizieller Markenshop und wird im Auftrag von {brand} betrieben.",
  [i18n.contents.texts.authRetailerTitle_d2c]: "Direkt vom Hersteller",
  [i18n.contents.texts.authRetailerText_d2c]: "{url} bietet Markenprodukte direkt vom Hersteller {brand}.",
  [i18n.contents.texts.shopCheckTitle_d2c]: 'Shop-Identität überprüft',
  [i18n.contents.texts.shopCheckText_d2c]: 'Die Unternehmensangaben zur Identität des Shopanbieters {url} wurden im Rahmen des TÜV Saarland ShopIdent Verfahrens zuletzt im {date} überprüft.',
  [i18n.contents.texts.shopCheckTitle_noTuv_d2c]: 'Sicher einkaufen',
  [i18n.contents.texts.shopCheckText_noTuv_d2c]: '{url} erfüllt die spezifischen Anforderungen von {brand} und ist der offizielle Markenshop.',

  [i18n.footer.showCertificate]: 'ZERTIFIKAT ANZEIGEN',
};
